export const SubdivisionURLs = {
    addView: '/subdivisions/add',
    editView: '/subdivisions/:id/edit',
    subdivisionView: '/subdivisions/:subdivisionId',
}